export default "__VITE_ASSET__KIn0PQOc__"